import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function TimerIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M8 6.5v2.4l1.47.9M8 3.8c-2.761 0-5 2.283-5 5.1S5.239 14 8 14s5-2.283 5-5.1-2.239-5.1-5-5.1m0 0V2M6.824 2h2.352M12.9 4.155l-.882-.9.441.45m-9.357.45.882-.9-.441.45" /></svg>
  );
}

export default TimerIcon;
